import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class MessageThreadApi extends EntityApi {
    protected static GET_COLLECTION = "/api/message-threads";

    protected static POST_COLLECTION = "/api/message-threads";

    protected static GET_ITEM = "/api/message-threads/{id}";

    protected static PUT_ITEM = "/api/message-threads/{id}";

    protected static PATCH_ITEM = "/api/message-threads/{id}";

    protected static DELETE_ITEM = "/api/message-threads/{id}";

    protected static GET_COLLECTION_NEW_MESSAGE_THREADS =
        "/api/message-threads/new-message-threads";

    public static async getCollectionNewMessageThreads<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_NEW_MESSAGE_THREADS,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
